import { render, staticRenderFns } from "./LocationColumn.vue?vue&type=template&id=c613786c"
import script from "./LocationColumn.vue?vue&type=script&lang=js"
export * from "./LocationColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports